// stripe.js
import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  process.env.REACT_APP_AUS_STRIPE_KEY
);
